import pendoSetup from "./pendo";

export default function analyticsSetup(analytics) {
    if(!analytics) { return; }

    if(analytics.pendo) { pendoSetup(analytics.pendo); }
}
